import PropTypes from 'prop-types';
import React from 'react';

const Numeration = ({ number }) => {
  return (
    <div className="numeration">
      <span className="numeration__number">{number}</span>
    </div>
  );
};

Numeration.propTypes = {
  number: PropTypes.number,
};

Numeration.defaultProps = {
  number: 0,
};

export default Numeration;
